import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { object } from "prop-types";
import { OrderedMap } from "immutable";
import AverageScoreScale from "components/DynamicScoreReportScales/AverageScoreScale";
import MultipleScoreScales from "components/DynamicScoreReportScales/MultipleScoreScales";
import { getCompetencyDetailRows } from "../../ScoreReportHelpers";

const Illustrait = ({
  candidateInfo,
  IllustraitWithoutCompetencySetAlert,
  reportInfo,
  SelectedScoreRangeSection,
  testScores,
}) => {
  const percentile = testScores.get("percentile");
  const hasCompetencySet = percentile !== null;

  const candidateFirstName = candidateInfo.get("testTakerFirstName");
  const reportText = reportInfo.get("text");

  const InterviewQuestionSections = [];

  let orderedCompetencyScores = new OrderedMap();

  if (hasCompetencySet) {
    reportText.get("competencyText").forEach((competencyText) => {
      const competencyId = competencyText.get("competencyId");
      const competencyName = competencyText.get("label");

      const matchingCompetency = reportText
        .get("competencies")
        .find((competency) => competency.get("competencyId") === competencyId);

      // Set competency name and score into OrderedMap to preserve order
      if (matchingCompetency) {
        orderedCompetencyScores = orderedCompetencyScores.set(
          competencyName,
          matchingCompetency.getIn(["score", "percentile"])
        );
      }

      let questionCount = 0;

      // Get interview question sections
      const questionListItems = competencyText
        .get("interviewQuestions")
        .map((question) => {
          questionCount += 1;
          return <li key={`${competencyId}-q${questionCount}`}>{question}</li>;
        });

      InterviewQuestionSections.push(
        <div key={competencyName}>
          <Badge className="badge-interview">{competencyName}</Badge>
          <ul>{questionListItems}</ul>
        </div>
      );
    });
  }

  return (
    <div>
      {hasCompetencySet ? (
        <>
          <Row className="mx-1 py-3">
            <Col>
              <h3 className="score-detail-section-heading">Results Details</h3>
              <AverageScoreScale score={percentile} testId={48} />
              {SelectedScoreRangeSection && (
                <div className="mt-5 mx-3" style={{ marginBottom: "-20px" }}>
                  {SelectedScoreRangeSection}
                </div>
              )}
              <p className="mt-5">{`${candidateFirstName}'s competency alignment was higher than ${percentile} percent of the population. Higher competency scores indicate a greater likelihood of
			the candidate having personality traits and preferences that are aligned with the competency requirements of
			the job.`}</p>
            </Col>
          </Row>
          <Row className="score-report-row">
            <Col>
              <h3 className="score-detail-section-heading">
                Competency Score Summary
              </h3>
              <Row className="competency-score-summary-row">
                <MultipleScoreScales
                  testId={48}
                  scores={orderedCompetencyScores}
                  maxScore={100}
                />
              </Row>
            </Col>
          </Row>
          <Row className="score-report-row">
            <Col>
              <h3 className="score-detail-section-heading">
                Competency Score Details
              </h3>
              {getCompetencyDetailRows(reportText, candidateFirstName)}
            </Col>
          </Row>
          <Row className="score-report-row">
            <Col>
              <h3 className="score-detail-section-heading">
                Interview Questions
              </h3>
              <p>
                {`The following interview questions are based on the competencies selected for the role and the
					individual's results on those competencies. The questions reflect areas that you may choose to
					investigate further if the candidate progresses to an interview.`}
              </p>
              {InterviewQuestionSections}
            </Col>
          </Row>
          <Row className="score-report-row">
            <Col>
              <h3 className="score-detail-section-heading">
                Validity & Response Style
              </h3>
              <p>
                Illustrait contains an internal Scatter Score which is designed
                to detect response patterns which deviate from an expected
                response pattern. The Scatter Score can be used to detect
                respondents who may have been careless or inattentive, as well
                as those attempting to present themselves in an overly positive
                light.
              </p>
              <Col lg={6}>
                <Row className="traitDescriptionBox px-2 flex-nowrap">
                  <Col lg={8}>
                    <h4 className="reportHeader mt-2 pl-1">Scatter Score</h4>
                  </Col>
                  <Col
                    style={{ color: "#19355f", fontSize: "21px" }}
                    className="font-weight-bold pl-3 mt-1"
                  >
                    {reportText.get("inconsistencyPercentile")}
                  </Col>
                </Row>
                <p className="mt-3">{reportText.get("incText")}</p>
              </Col>
            </Col>
          </Row>
        </>
      ) : (
        IllustraitWithoutCompetencySetAlert
      )}
    </div>
  );
};

Illustrait.propTypes = {
  candidateInfo: object,
  IllustraitWithoutCompetencySetAlert: object,
  reportInfo: object,
  SelectedScoreRangeSection: object,
  testScores: object,
};

export default Illustrait;
